<template>
  <div class="merchant-promotional-coupons">
    <div class="page-header">
      <h2>商户优惠券管理</h2>
      <p>管理商户信息、优惠券领取规则和优惠券列表</p>
    </div>
    
    <div class="feature-cards">
      <div class="card" @click="navigateTo('/main/merchant-promotional-coupons/merchant-management')">
        <div class="card-icon">
          <i class="el-icon-shop"></i>
        </div>
        <div class="card-content">
          <h3>商户管理</h3>
          <p>管理商户基本信息，包括商家名称、地址、电话、营业时间、经纬度、商家图片、手机号等</p>
          <ul class="feature-list">
            <li>• 商家名称、地址、电话</li>
            <li>• 营业时间、经纬度</li>
            <li>• 商家图片、手机号</li>
            <li>• 关联商户分类</li>
          </ul>
        </div>
      </div>
      
      <div class="card" @click="navigateTo('/main/merchant-promotional-coupons/coupon-rules')">
        <div class="card-icon">
          <i class="el-icon-setting"></i>
        </div>
        <div class="card-content">
          <h3>领取规则</h3>
          <p>配置优惠券领取规则，包括分道路设置、时间段配置和有效期管理</p>
          <ul class="feature-list">
            <li>• 分道路设置领取开关</li>
            <li>• 按时间设置领取次数</li>
            <li>• 设置领取有效期</li>
            <li>• 多时段特定次数配置</li>
          </ul>
        </div>
      </div>
      
      <div class="card" @click="navigateTo('/main/merchant-promotional-coupons/coupon-list')">
        <div class="card-icon">
          <i class="el-icon-tickets"></i>
        </div>
        <div class="card-content">
          <h3>优惠券列表</h3>
          <p>管理优惠券信息，包括优惠券内容、发放数量、使用情况、状态管理和审核流程</p>
          <ul class="feature-list">
            <li>• 优惠券名称、类型、内容</li>
            <li>• 发放数量、已领取数量、已使用数量</li>
            <li>• 上架有效期和使用有效期</li>
            <li>• 状态管理和审核流程</li>
          </ul>
        </div>
      </div>
      
      <div class="card" @click="navigateTo('/main/merchant-promotional-coupons/receive-record')">
        <div class="card-icon">
          <i class="el-icon-download"></i>
        </div>
        <div class="card-content">
          <h3>领取记录</h3>
          <p>查看优惠券领取记录，包括用户信息、领取时间、使用状态等详细信息</p>
          <ul class="feature-list">
            <li>• 用户手机号、姓名</li>
            <li>• 领取时间、使用时间</li>
            <li>• 优惠券有效期</li>
            <li>• 领取状态统计</li>
          </ul>
        </div>
      </div>
      
      <div class="card" @click="navigateTo('/main/merchant-promotional-coupons/verification-record')">
        <div class="card-icon">
          <i class="el-icon-check"></i>
        </div>
        <div class="card-content">
          <h3>核销记录</h3>
          <p>查看优惠券核销记录，包括核销时间、金额、人员、方式等详细信息</p>
          <ul class="feature-list">
            <li>• 核销时间、金额</li>
            <li>• 核销人员、方式</li>
            <li>• 核销状态统计</li>
            <li>• 退款记录管理</li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="status-overview">
      <h3>系统状态概览</h3>
      <div class="status-cards">
        <div class="status-card">
          <div class="status-number">{{ overviewData.merchantCount }}</div>
          <div class="status-label">商户总数</div>
        </div>
        <div class="status-card">
          <div class="status-number">{{ overviewData.activeRules }}</div>
          <div class="status-label">活跃规则</div>
        </div>
        <div class="status-card">
          <div class="status-number">{{ overviewData.totalCoupons }}</div>
          <div class="status-label">优惠券总数</div>
        </div>
        <div class="status-card">
          <div class="status-number">{{ overviewData.pendingAudit }}</div>
          <div class="status-label">待审核</div>
        </div>
        <div class="status-card">
          <div class="status-number">{{ overviewData.totalReceived }}</div>
          <div class="status-label">总领取数</div>
        </div>
        <div class="status-card">
          <div class="status-number">{{ overviewData.totalVerified }}</div>
          <div class="status-label">总核销数</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "merchant-promotional-coupons-index",
  data() {
    return {
      overviewData: {
        merchantCount: 0,
        activeRules: 0,
        totalCoupons: 0,
        pendingAudit: 0,
        totalReceived: 0,
        totalVerified: 0
      }
    };
  },
  mounted() {
    this.loadOverviewData();
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    },
    
    loadOverviewData() {
      // 这里可以调用API获取概览数据
      // 暂时使用模拟数据
      this.overviewData = {
        merchantCount: 156,
        activeRules: 23,
        totalCoupons: 89,
        pendingAudit: 12,
        totalReceived: 4567,
        totalVerified: 2341
      };
    }
  }
};
</script>

<style scoped>
.merchant-promotional-coupons {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 30px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 10px;
}

.page-header h2 {
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: 600;
}

.page-header p {
  margin: 0;
  font-size: 16px;
  opacity: 0.9;
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  border-color: #409EFF;
}

.card-icon {
  text-align: center;
  margin-bottom: 20px;
}

.card-icon i {
  font-size: 48px;
  color: #409EFF;
}

.card-content h3 {
  margin: 0 0 15px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.card-content p {
  margin: 0 0 20px 0;
  color: #666;
  line-height: 1.6;
  text-align: center;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  padding: 5px 0;
  color: #555;
  font-size: 14px;
}

.status-overview {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.status-overview h3 {
  margin: 0 0 25px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
}

.status-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
}

.status-card {
  text-align: center;
  padding: 25px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 10px;
  color: white;
}

.status-card:nth-child(2) {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.status-card:nth-child(3) {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.status-card:nth-child(4) {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.status-card:nth-child(5) {
  background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
}

.status-card:nth-child(6) {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

.status-number {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
}

.status-label {
  font-size: 14px;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .feature-cards {
    grid-template-columns: 1fr;
  }
  
  .status-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .status-cards .status-card:nth-child(5),
  .status-cards .status-card:nth-child(6) {
    grid-column: span 1;
  }
  
  .page-header {
    padding: 20px;
  }
  
  .page-header h2 {
    font-size: 24px;
  }
}
</style>
